(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rayhope-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRhMore() {
      var buttons = document.querySelectorAll('.rh-market .rh-more');
      buttons.forEach(function (btn) {
        if (btn.dataset.rhBound) return;
        btn.dataset.rhBound = '1';
        btn.addEventListener('click', function () {
          var card = btn.closest('.rh-market');
          if (!card) return;
          var open = card.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open ? 'Show less' : 'Show all applications';
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRhMore);
    } else {
      initRhMore();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
